import {
  Tabs,
  Tab,
  Box,
  IconButton,
  Menu,
  MenuItem,
  Button,
  SelectChangeEvent,
} from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import React, { SyntheticEvent, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import SearchBar from '../../components/SearchBar';
import { showError, showToast } from '../../constants/toasts';
import ApprovedDealerListings from '../../features/listings/dealer/approvedDealerListings';
import NewDealerListings from '../../features/listings/dealer/newDealerListings';
import RejectedDealerListings from '../../features/listings/dealer/rejectedDealerListings';
import { successToast } from '../../helpers';
import MainContainer from '../../layout/MainContainer';
import { ConfirmationModal } from '../../Modals/confirmationModal';
import ResonOfRejection from '../../Modals/reasonOfRejection';
import {
  useLazyDeleteListingQuery,
  useLazyGetListingsQuery,
  useUpdateListingMutation,
} from '../../service/listing';
import { CommonBody, Listing } from '../../types/General';
import { generateEncryptedKeyBody } from '../../utils/crypto';
import {
  APPROVAL_STATUS,
  SOLD_STATUS,
  UPDATE_TYPES,
  USER_TYPE,
  VEHICLE_TYPE,
} from '../../utils/enums';
import { isValidInput } from '../../utils/validations';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const DealerListings = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>('');
  const [valueTabs, setValueTabs] = useState(APPROVAL_STATUS.PENDING);
  const [newListings, setNewListings] = useState<number>(0);
  const [approvedListings, setApprovedListings] = useState<number>(0);
  const [rejectedListings, setRejectedListings] = useState<number>(0);
  const [selectedId, setSelectedId] = useState('');
  const [open, setOpen] = useState(false);
  const [modalType, setModalType] = useState('');
  const [rejectionOpen, setRejectionOpen] = useState<boolean>(false);
  const [rejectionRsn, setRejectionRsn] = useState<string>('');

  const [getListings] = useLazyGetListingsQuery();
  const [updateListing] = useUpdateListingMutation();
  const [deleteListing] = useLazyDeleteListingQuery();

  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState<Listing[]>([]);
  const [page, setPage] = useState<number>(1);

  const handlePageChange = (event: any, newPage: number) => {
    setPage(newPage + 1);
  };

  const handleChangeTabs = (event: SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };
  const [anchorEl1, setAnchorEl1] = React.useState<null | HTMLElement>(null);
  const open1 = Boolean(anchorEl1);

  const handleClick1 = (event: React.MouseEvent<HTMLButtonElement>, rowId: string) => {
    setAnchorEl1(event.currentTarget);
    setSelectedId(rowId);
  };
  const handleClose1 = () => {
    setAnchorEl1(null);
    setSelectedId('');
  };

  const handleSoldChange = async (event: SelectChangeEvent<string>, id: string) => {
    const val = event.target.value as keyof typeof SOLD_STATUS;

    const body = {
      soldStatus: SOLD_STATUS[val],
    };

    try {
      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const response = await updateListing({
        body: encryptedBody,
        id,
      }).unwrap();
      if (response?.statusCode === 200) {
        // getVehicleList();
        const updatedData = rows?.map((item) => {
          if (item?._id === id) {
            return {
              ...item,
              soldStatus: SOLD_STATUS[val],
            };
          }
          return item;
        });

        setRows(updatedData);
        if (val === SOLD_STATUS[3]) {
          showToast('Approved successfully');
        } else if (val === SOLD_STATUS[4]) {
          showToast('Rejected successfully');
        }
      } else {
        showError('Please try again');
      }
    } catch (error: any) {
      console.error(error, 'errror');
      showError(error?.data?.message || '');
    }

    // Optional: update the row or trigger API call here
  };

  const columns: GridColDef<(typeof rows)[number]>[] = [
    {
      flex: 0.6,
      minWidth: 100,
      field: 'vehicle',
      headerName: 'Vehicle Details',
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="sq_image" style={{ marginTop: '16px' }}>
            <figure
              style={{ cursor: 'pointer' }}
              onClick={() => navigate(`/listing-detail/${row?.vehicleType}/${row?._id}`)}
            >
              <img src={row?.coverImage || '/static/images/picture.png'} alt="Vehicle" />
            </figure>
            <p>
              <b>{row?.title || '-'}</b>
            </p>
          </div>
        );
      },
    },
    {
      flex: 0.4,
      minWidth: 100,
      field: 'vehicleType',
      headerName: 'Vehicle Type',
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>
              <b>
                {row?.vehicleType === VEHICLE_TYPE.CAR
                  ? 'Car'
                  : row?.vehicleType === VEHICLE_TYPE.BIKE
                    ? 'Bike'
                    : row?.vehicleType === VEHICLE_TYPE.TRUCK
                      ? 'Truck'
                      : row?.vehicleType === VEHICLE_TYPE.HEAVY_VEHICLE
                        ? 'Heavy Vehicle'
                        : '- -'}
              </b>
            </p>
          </div>
        );
      },
    },
    {
      flex: 0.8,
      minWidth: 200,
      field: 'name',
      headerName: 'Seller Details',
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <figure>
              <img src={row?.userImage || '/static/images/user_placeholder.png'} alt="User" />
            </figure>
            <p>
              <b>{row?.name || '-'}</b> {row?.dialCode} {row?.phoneNo || '-'}
              <br />
              {row?.email || '-'}
            </p>
          </div>
        );
      },
    },

    {
      flex: 0.1,
      minWidth: 80,
      field: 'action',
      headerName: 'Action',
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="table_actions">
            <Box>
              <IconButton
                aria-controls={open1 ? 'basic-menu1' : undefined}
                aria-haspopup="true"
                aria-expanded={open1 ? 'true' : undefined}
                onClick={(event) => handleClick1(event, row._id)}
              >
                <img src="/static/images/more_icon.svg" alt="" />
              </IconButton>
              <Menu
                className="setting_menu"
                id="basic-menu1"
                anchorEl={anchorEl1}
                open={open1}
                onClose={handleClose1}
                MenuListProps={{
                  'aria-labelledby': 'basic-button1',
                }}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: 'visible',
                    boxShadow: '0px 4px 20px 0px rgba(0, 0, 0, 0.05)',
                    borderRadius: '8px',
                    mt: 1,
                  },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
              >
                <MenuItem
                  onClick={() => {
                    if (selectedId) {
                      setModalType(UPDATE_TYPES.ACCEPT);
                      setAnchorEl1(null);
                      setOpen(true);
                    }
                  }}
                >
                  Approve
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    if (selectedId) {
                      setAnchorEl1(null);
                      setModalType(UPDATE_TYPES.REJECT);
                      setRejectionOpen(true);
                      // setOpen(true);
                    }
                  }}
                >
                  Reject
                </MenuItem>
                <MenuItem
                  onClick={() => navigate(`/listing-detail/${row?.vehicleType}/${selectedId}`)}
                >
                  View
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    navigate(`/listings/edit/${selectedId}`);
                    handleClose1();
                  }}
                >
                  Edit
                </MenuItem>
              </Menu>
            </Box>
          </div>
        );
      },
    },
  ];

  const handleUserUpdate = async (id: string, status: any, type: string) => {
    const body = {
      ...(type === UPDATE_TYPES.BLOCK
        ? { isBlocked: status }
        : type === UPDATE_TYPES.ADD_TO_PREMIUM
          ? { isPremiumCar: status }
          : {}),
    };

    try {
      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const response = await updateListing({
        body: encryptedBody,
        id: id,
      }).unwrap();
      if (response?.statusCode === 200) {
        const updatedData = rows?.map((item) => {
          if (item?._id === id) {
            if (type === UPDATE_TYPES.BLOCK) {
              return {
                ...item,
                isBlocked: status,
              };
            } else if (type === UPDATE_TYPES.ADD_TO_PREMIUM) {
              return {
                ...item,
                isPremiumCar: status,
              };
            }
          }
          return item;
        });

        setRows(updatedData);
        if (type === UPDATE_TYPES.BLOCK) {
          if (status) {
            showToast('Blocked successfully');
          } else {
            showToast('Unblocked successfully');
          }
        } else if (type === UPDATE_TYPES.ADD_TO_PREMIUM) {
          if (status) {
            showToast('Added to premium listing successfully');
          } else {
            showToast('Removed from premium listing successfully');
          }
        }
      } else {
        showError('Please try again');
      }
    } catch (error: any) {
      console.error(error, 'errror');
      showError(error?.data?.message || '');
    }
  };

  const handleApproveReject = async () => {
    setRejectionOpen(false);
    const body = {
      status: modalType === 'accept' ? 2 : 3,
      ...(modalType === 'reject' && { rejectionReason: rejectionRsn }),
    };
    setRejectionRsn('');

    try {
      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const response = await updateListing({
        body: encryptedBody,
        id: selectedId,
      }).unwrap();
      if (response?.statusCode === 200) {
        successToast(
          modalType === 'accept'
            ? 'Vehicle listing approved successfully'
            : 'Vehicle listing rejected successfully'
        );
        if (modalType === 'accept') {
          setValueTabs(APPROVAL_STATUS.APPROVED);
          setPage(1);
        } else {
          setValueTabs(APPROVAL_STATUS.REJECTED);
          setPage(1);
        }
      } else {
        showError('Please try again');
      }
    } catch (error: any) {
      setLoading(false);
      console.error(error, 'errror');
      showError(error?.data?.message || '');
    }
  };

  const getVehicleList = async () => {
    setLoading(true);
    try {
      const response = await getListings({
        page: page,
        limit: 10,
        search: debouncedSearchTerm.trim(),
        role: USER_TYPE.DEALER,
        status: valueTabs + 1,
      }).unwrap();
      setLoading(false);

      if (response?.statusCode === 200) {
        setRows(response?.data?.data || []);
        setCount(response?.data?.count);
        setNewListings(response?.data?.pendingCount);
        setApprovedListings(response?.data?.approvedCount);
        setRejectedListings(response?.data?.rejectCount);
      } else {
        setRows([]);
      }
    } catch (error: any) {
      showError(error?.data?.message || '');
      setLoading(false);
    }
  };

  const handleDeleteListing = async () => {
    setLoading(true);
    try {
      const response = await deleteListing({
        id: selectedId,
      }).unwrap();
      setLoading(false);

      if (response?.statusCode === 200) {
        showToast('Deleted successfully');
        getVehicleList();
      } else {
        setRows([]);
      }
    } catch (error: any) {
      showError(error?.data?.message || '');
      setLoading(false);
    }
  };

  useEffect(() => {
    getVehicleList();
  }, [debouncedSearchTerm, page, valueTabs]);

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Dealer Listings </h1>
        <p>
          <span onClick={() => navigate('/dashboard')}>Dashboard</span> - Listings - Dealer Listings
        </p>
      </div>
      <div className="cards">
        <Box className="custom_tabs" sx={{ width: '100%' }}>
          <div className="table_header">
            <div className="left_s">
              <Box className="search_box">
                <SearchBar
                  searchTerm={searchTerm}
                  placeholder="Search"
                  setDebouncedSearchTerm={setDebouncedSearchTerm}
                  value={searchTerm}
                  onCross={() => setSearchTerm('')}
                  onChange={(val: any) => {
                    if (isValidInput(val.target.value)) {
                      setSearchTerm(val.target.value);
                    }
                  }}
                />
              </Box>
            </div>
            <div className="right_s">
              <Box>
                <Button className="btn btn_orange" onClick={() => navigate('/listings/add')}>
                  Add Vehicle
                </Button>
              </Box>
            </div>
            {/* <div className="right_s">
              <Box>
                <Button className="btn btn_highlight">
                  <img src="/static/images/upload_icon.svg" alt="Icon" /> Export
                  CSV
                </Button>
              </Box>
            </div> */}
          </div>

          <Tabs
            value={valueTabs}
            onChange={handleChangeTabs}
            aria-label="basic tabs example"
            className="custom_tabs_links"
          >
            <Tab label={`New Listings (${newListings})`} {...a11yProps(APPROVAL_STATUS.PENDING)} />
            <Tab
              label={`Approved Listings (${approvedListings})`}
              {...a11yProps(APPROVAL_STATUS.APPROVED)}
            />
            <Tab
              label={`Rejected Listings (${rejectedListings})`}
              {...a11yProps(APPROVAL_STATUS.REJECTED)}
            />
          </Tabs>

          <CustomTabPanel value={valueTabs} index={APPROVAL_STATUS.PENDING}>
            <NewDealerListings
              rows={rows}
              columns={columns}
              count={count}
              page={page}
              onPageChange={handlePageChange}
              loading={loading}
            />
          </CustomTabPanel>
          <CustomTabPanel value={valueTabs} index={APPROVAL_STATUS.APPROVED}>
            <ApprovedDealerListings
              count={count}
              rows={rows}
              page={page}
              onPageChange={handlePageChange}
              loading={loading}
              setUsers={setRows}
              setSelectedId={setSelectedId}
              handleSoldChange={handleSoldChange}
              // handleDeleteUser={handleDeleteUser}
              handleUserUpdate={handleUserUpdate}
              setModalType={setModalType}
              setOpen={setOpen}
              selectedId={selectedId}
            />
          </CustomTabPanel>
          <CustomTabPanel value={valueTabs} index={APPROVAL_STATUS.REJECTED}>
            <RejectedDealerListings
              count={count}
              rows={rows}
              page={page}
              onPageChange={handlePageChange}
              loading={loading}
              setSelectedId={setSelectedId}
              selectedId={selectedId}
              setOpen={setOpen}
              setModalType={setModalType}
            />
          </CustomTabPanel>
        </Box>

        <ResonOfRejection
          selectedId={selectedId}
          rejectionRsn={rejectionRsn}
          setRejectionRsn={setRejectionRsn}
          open={rejectionOpen}
          setOpen={setRejectionOpen}
          onClose={handleApproveReject}
        />

        <ConfirmationModal
          text={
            modalType === 'delete'
              ? 'Are you sure to delete this listing?'
              : modalType === 'accept'
                ? 'Are you sure to approve this listing?'
                : modalType === 'reject'
                  ? 'Are you sure to reject this listing?'
                  : ''
          }
          openModal={open}
          setOpenModal={setOpen}
          handleSubmit={
            modalType === 'delete'
              ? handleDeleteListing
              : modalType === 'accept' || modalType === 'reject'
                ? () => handleApproveReject()
                : () => {}
          }
        />
      </div>
    </MainContainer>
  );
};

export default DealerListings;
